import { createDecorator } from '../../instantiation/common/instantiation.js';
const IContextKeyService = ( createDecorator('contextKeyService'));
export { IContextKeyService };
